import React from "react";
import { Tooltip } from "@mui/material";
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { AddressData } from "@caredna-marlin/utils/client/geocoding";

interface Props {
  preText?: string;
  address: AddressData;
}

const formatAddress = (addr: AddressData): string => {
  const parts = [
    addr.addressStreet,
    addr.addressLineTwo,
    addr.addressCity,
    addr.addressState,
    addr.addressZip
  ].filter(Boolean);
  
  return parts.join(', ');
};

const LocationTooltip: React.FC<Props> = ({ 
  address, 
  preText = '',
}) => {
  const addressText = formatAddress(address);

  return (
    <Tooltip 
      title={`${preText}${addressText}`} 
      arrow
      placement="top"
    >
      <GpsFixedIcon 
        sx={{ ml: 1, verticalAlign: 'middle', width: 18, height: 18, color: 'gray' }} 
        onMouseEnter={(e) => e.stopPropagation()}
        onMouseLeave={(e) => e.stopPropagation()}
      />
    </Tooltip>
  );
};

export default LocationTooltip;